import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-salesribbon', 'close', 'Закрыть');
